import { Injectable } from "@angular/core";
import { FooterLinkImpressumExtension } from "@geolib/geoappbase-client";
import { AppConstants } from "../common/app-constants";

@Injectable({ providedIn: "root" })
export default class GeobusFooterLinkImpressumExtension extends FooterLinkImpressumExtension {

    public get linkUrl(): string {
        return AppConstants.PATH_OF_IMPRESSUM;
    }
}
